<template>
    <div>
    
        <h1>Check your report</h1>
    
        <span class="npfSubQuestion">Please check the summary below before submitting your report.</span>
    
        <br>
    
        <b-card class="cardboardTop" title="About you">
    
            <!-- <rowCompentnpf
    
            :title="'Please tell us what kind of incident you are reporting'"
    
            :answer="viewModel.typeOfIndident"
    
            :pagenum="1"
    
            v-on:gotToedit="gotToedit"
    
          /> -->
    
    
    
            <rowCompentnpf :title="'Title'" :answer="viewModel.ReportingPerson.title" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'First Name'" :answer="viewModel.ReportingPerson.firstname" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Middle Name'" :answer="viewModel.ReportingPerson.middlename" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Last name'" :answer="viewModel.ReportingPerson.surname" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Date of Birth'" :answer="viewModel.ReportingPerson.dobday +'/'+viewModel.ReportingPerson.dobmonth+'/'+viewModel.ReportingPerson.dobyear" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Phone number'" :answer="viewModel.ReportingPerson.phonenumber" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Alternative phone number'" :answer="viewModel.ReportingPerson.phonenumberother" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Email address'" :answer="viewModel.ReportingPerson.email" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Building name'" :answer="viewModel.ReportingPerson.Address.BuidlingName" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Building number'" :answer="viewModel.ReportingPerson.Address.BuildingNumber" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Street'" :answer="viewModel.ReportingPerson.Address.Street" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Town or city'" :answer="viewModel.ReportingPerson.Address.Town" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'County'" :answer="viewModel.ReportingPerson.Address.County" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Postcode'" :answer="viewModel.ReportingPerson.Address.PostCode" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'I can not provide the address'" :answer="viewModel.ReportingPerson.Address.NotProvideAddress" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'What is your gender?'" :answer="viewModel.ReportingPerson.gender" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'What is your ethnicity?'" :answer="viewModel.ReportingPerson.ethnicity" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Do you have a disability or access need?'" :answer="viewModel.ReportingPerson.disability" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            <div v-if="viewModel.ReportingPerson.disability == 'Yes'">
    
                <rowCompentnpf :title="'Please provide details of your disability or access need'" :answer="viewModel.ReportingPerson.disabilityDetails" :pagenum="2" v-on:gotToedit="gotToedit" />
    
            </div>
    
        </b-card>
    
        <div v-if="viewModel.typeOfIndident == 'B'">
    
            <br>
    
            <b-card class="cardboardTop" title="About the Victim">
    
                <rowCompentnpf :title="'Do You Known the Victim'" :answer="viewModel.doyouknowntoVic" :pagenum="1" v-on:gotToedit="gotToedit" />
    
    
    
                <rowCompentnpf :title="'Title'" :answer="viewModel.Victim.title" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'First Name'" :answer="viewModel.Victim.firstname" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Middle Name'" :answer="viewModel.Victim.middlename" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Last name'" :answer="viewModel.Victim.surname" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Date of Birth'" :answer="viewModel.Victim.dobday +'/'+viewModel.Victim.dobmonth+'/'+viewModel.Victim.dobyear" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Phone number'" :answer="viewModel.Victim.phonenumber" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Alternative phone number'" :answer="viewModel.Victim.phonenumberother" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Email address'" :answer="viewModel.Victim.email" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Building name'" :answer="viewModel.Victim.Address.BuidlingName" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Building number'" :answer="viewModel.Victim.Address.BuildingNumber" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Street'" :answer="viewModel.Victim.Address.Street" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Town or city'" :answer="viewModel.Victim.Address.Town" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'County'" :answer="viewModel.Victim.Address.County" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Postcode'" :answer="viewModel.Victim.Address.PostCode" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'I can not provide the address'" :answer="viewModel.Victim.Address.NotProvideAddress" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'What is your gender?'" :answer="viewModel.Victim.gender" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'What is your ethnicity?'" :answer="viewModel.Victim.ethnicity" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Do you have a disability or access need?'" :answer="viewModel.Victim.disability" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                <div v-if="viewModel.Victim.disability == 'Yes'">
    
                    <rowCompentnpf :title="'Please provide details of your disability or access need'" :answer="viewModel.Victim.disabilityDetails" :pagenum="2" v-on:gotToedit="gotToedit" />
    
                </div>
    
            </b-card>
    
    
    
        </div>
    
        <br>
    
        <b-card class="cardboardTop" title="About the incident">
    
            <rowCompentnpf :title="'Something was stolen'" :answer="viewModel.incident.typeOfIncident.indexOf('Something was stolen') > -1 " :pagenum="3" v-on:gotToedit="gotToedit" />
    
    
    
            <rowCompentnpf :title="'Physical or verbal assault'" :answer="viewModel.incident.typeOfIncident.indexOf('Physical or verbal assault') > -1 " :pagenum="3" v-on:gotToedit="gotToedit" />
    
    
    
            <rowCompentnpf :title="'Criminal damage or anti-social behaviour'" :answer="viewModel.incident.typeOfIncident.indexOf('Criminal damage or anti-social behaviour') > -1 " :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Witnessed something suspicious'" :answer="viewModel.incident.typeOfIncident.indexOf('Witnessed something suspicious') > -1 " :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Something else not in this list'" :answer="viewModel.incident.typeOfIncident.indexOf('Something else not in this list') > -1 " :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Start date'" :answer="viewModel.incident.startday +'/'+viewModel.incident.startmonth +'/'+viewModel.incident.startyear" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Start time'" :answer="viewModel.incident.startTime" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'End date'" :answer="viewModel.incident.endday +'/'+viewModel.incident.endmonth +'/'+viewModel.incident.endyear" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'End time'" :answer="viewModel.incident.endtime" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'I know the address'" :answer="viewModel.incident.Address.NotProvideAddress" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <div v-if="viewModel.incident.Address.NotProvideAddress == true">
    
                <rowCompentnpf :title="'Building name'" :answer="viewModel.incident.Address.BuidlingName" :pagenum="3" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Building number'" :answer="viewModel.incident.Address.BuildingNumber" :pagenum="3" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Street'" :answer="viewModel.incident.Address.Street" :pagenum="3" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Town or city'" :answer="viewModel.incident.Address.Town" :pagenum="3" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'County'" :answer="viewModel.incident.Address.County" :pagenum="3" v-on:gotToedit="gotToedit" />
    
                <rowCompentnpf :title="'Postcode'" :answer="viewModel.incident.Address.PostCode" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            </div>
    
            <rowCompentnpf :title="'Describe the location'" :answer="viewModel.incident.decriptionOfLocation" :pagenum="3" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Describe the incident in your own words'" :answer="viewModel.incident.decribeIncident" :pagenum="3" v-on:gotToedit="gotToedit" />
    
        </b-card>
    
    
    
    
    
        <br>
    
        <b-card class="cardboardTop" title="About any suspects">
    
            <div v-if="viewModel.suspects.listofSuspects.length<1">
    
                <rowCompentnpf :title="'None reported'" :answer="''" :pagenum="4" v-on:gotToedit="gotToedit" />
    
            </div>
    
            <div v-if="viewModel.suspects.listofSuspects.length>0">
    
                <div v-for="(value, index) in viewModel.suspects.listofSuspects" v-bind:key="value.Name">
    
                    <b-card :title="'Suspect '+ (index+1)">
    
                        <rowCompentnpf :title="'Name'" :answer="value.Name" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Gender'" :answer="value.Gender" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Approximate Age'" :answer="value.aproxAge" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Approximate Height'" :answer="value.aproxHeight" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Build'" :answer="value.build" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Eye Colour'" :answer="value.eyecolour" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Hair Colour'" :answer="value.haircolour" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Hair Style'" :answer="value.hairstyle" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Any Other Details'" :answer="value.OtherDeteails" :pagenum="4" v-on:gotToedit="gotToedit" />
    
                    </b-card>
    
    
    
                    <br>
    
                </div>
    
    
    
            </div>
    
    
    
        </b-card>
    
        <br>
    
        <b-card class="cardboardTop" title="Were any personal belongings lost, stolen or damaged in the incident?">
    
            <rowCompentnpf :title="'A vehicle'" :answer="viewModel.property.vehicle" :pagenum="5" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'An electronic device'" :answer="viewModel.property.electronicDevice" :pagenum="5" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'A bag or wallet'" :answer="viewModel.property.bagorwallet" :pagenum="5" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Something else not in this list'" :answer="viewModel.property.somthingelse" :pagenum="5" v-on:gotToedit="gotToedit" />
    
        </b-card>
    
    
    
        <div v-if="viewModel.property.listofVehicles.length>0">
    
            <br>
    
            <b-card class="cardboardTop" title="About the vehicles involved">
    
                <div v-for="(value, index) in viewModel.property.listofVehicles" v-bind:key="value.VRM">
    
                    <b-card :title="'Vehicle '+ (index+1)">
    
                        <rowCompentnpf :title="'Type of vehicle'" :answer="value.type" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Make and model'" :answer="value.makeandModel" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Number plate or vehicle identification number'" :answer="value.VRM" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Any other information'" :answer="value.anyotherinfo" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                    </b-card>
    
                    <br>
    
                </div>
    
                <br>
    
            </b-card>
    
        </div>
    
    
    
        <div v-if="viewModel.property.listofelectronicDevice.length>0">
    
            <br>
    
            <b-card class="cardboardTop" title="About the electronic devices involved">
    
                <div v-for="(value, index) in viewModel.property.listofelectronicDevice" v-bind:key="value.imei">
    
                    <b-card :title="'Device '+ (index+1)">
    
                        <rowCompentnpf :title="'Type of device'" :answer="value.type" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Make and model'" :answer="value.makeandmodel" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'IMEI code or serial number, if known'" :answer="value.imei" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Any other information'" :answer="value.anyother" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                    </b-card>
    
    
    
                    <br>
    
                </div>
    
            </b-card>
    
        </div>
    
    
    
        <div v-if="viewModel.property.listofbagorwallet.length>0">
    
            <br>
    
            <b-card class="cardboardTop" title="About the bags or wallets involved">
    
                <div v-for="(value, index) in viewModel.property.listofbagorwallet" v-bind:key="value.describeitem">
    
                    <b-card :title="'Item '+ (index+1)">
    
                        <rowCompentnpf :title="'Type of item'" :answer="value.type" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Describe the item'" :answer="value.describeitem" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                        <rowCompentnpf :title="'Describe any contents'" :answer="value.describecontents" :pagenum="5" v-on:gotToedit="gotToedit" />
    
                    </b-card>
    
    
    
                    <br>
    
                </div>
    
            </b-card>
    
        </div>
    
    
    
        <div v-if="viewModel.property.somthingelse == true">
    
            <br>
    
            <b-card class="cardboardTop" title="About the other belongings involved">
    
                <rowCompentnpf :title="'Describe the items in as much detail as possible'" :answer="viewModel.property.somthingelseDetails" :pagenum="5" v-on:gotToedit="gotToedit" />
    
            </b-card>
    
        </div>
    
        <br>
    
        <b-card class="cardboardTop" title="About any evidence">
    
            <rowCompentnpf :title="'Is there any evidence from the incident or at the scene?'" :answer="viewModel.evidence.anyevidence" :pagenum="6" v-on:gotToedit="gotToedit" />
    
            <rowCompentnpf :title="'Describe the evidence'" :answer="viewModel.evidence.describeEvidence" :pagenum="6" v-on:gotToedit="gotToedit" />
    
        </b-card>
    
        <br>
    
        <b-card class="cardboardTop" title="Additional information">
    
            <rowCompentnpf :title="'Is this related to any other crimes or incidents?'" :answer="viewModel.additionalInfo.isthisrelatedtoanyothercrime" :pagenum="7" v-on:gotToedit="gotToedit" />
    
            <div v-if="viewModel.additionalInfo.isthisrelatedtoanyothercrime == 'Yes'">
    
                <rowCompentnpf :title="'Briefly list the previous crimes or incidents'" :answer="viewModel.additionalInfo.isthisrelatedtoanyothercrimeDetails" :pagenum="7" v-on:gotToedit="gotToedit" />
    
            </div>
    
    
    
            <rowCompentnpf :title="'Do you feel you are being targeted?'" :answer="viewModel.additionalInfo.doyoufeelyourbeingtargeted" :pagenum="7" v-on:gotToedit="gotToedit" />
    
            <div v-if="viewModel.additionalInfo.isthisrelatedtoanyothercrime == 'Yes'">
    
                <rowCompentnpf :title="'Tell us why you feel you are being targeted'" :answer="viewModel.additionalInfo.doyoufeelyourbeingtargetedDetails" :pagenum="7" v-on:gotToedit="gotToedit" />
    
            </div>
    
            <rowCompentnpf :title="'Is there any other information you think may be relevant?'" :answer="viewModel.additionalInfo.isthereanyotherrelevantinformation" :pagenum="7" v-on:gotToedit="gotToedit" />
    
        </b-card>
    
        <br>
    
    </div>
</template>

<script>
import rowCompentnpf from "../components/RowComponent.vue";

export default {
    components: {
        rowCompentnpf
    },

    props: ["viewModel"],
    methods: {
        gotToedit(pagnum) {
            this.$emit("gotToedit", pagnum);
        }
    },
    created: function() {}
};
</script>

<style>
.npfsummaryrow {
    margin-left: 2px;
    margin-right: 2px;
    border-style: solid;
    border-width: thin;
    border-color: darkgray;
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>
